import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { analytics } from "./plugins/analytics";
// Element Plus components are auto-imported via unplugin-vue-components
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import { useLocalStorage } from "./stores";
import { VueReCaptcha } from "vue-recaptcha-v3";
import "./assets/global.css"; // The path might vary depending on your project structure.

const app = createApp(App);

const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(VueReCaptcha, { siteKey: import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY });
app.use(analytics);

app.directive("click-outside", {
  beforeMount: function (element, binding) {
    element.clickOutsideEvent = function (event) {
      if (!(element === event.target || element.contains(event.target))) {
        binding.value();
      }
    };
    document.body.addEventListener("click", element.clickOutsideEvent);
  },
  unmounted: function (element) {
    document.body.removeEventListener("click", element.clickOutsideEvent);
  },
});

app.mount("#app");
useLocalStorage();
